export default "__VITE_ASSET__2auam8CV__"